var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4a3f4656c032b2b4603487cff557a5079673c172"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["community-schools-vue@scid-solutions"]={id:"4a3f4656c032b2b4603487cff557a5079673c172"};
      